<template>
	<div class="page-content">
  <script data-n-head="true" type="application/ld+json">{
	  "@context":"http://schema.org",
	  "@type":"BreadcrumbList","itemListElement":[
		  {
			  "@type":"ListItem",
			  "position":1,
			  "item":"https://GameEnable.com/article/","name":"Articles"
		  },
		  {
			  "@type":"ListItem",
			  "position":2,
			  "item":"https://GameEnable.com/article/{{id}}","name":"{{title}}"
		  }
	  ]
  }</script>
		 	<v-card style="margin-top:10px;">

			  <v-card-title style="font-size: 26px; " class="text-action">{{title}}</v-card-title>




    <v-card-text class="text--primary" ><br>
   			<span v-html="$t('blog.registerUnsupportedCountriesBlogContent_1')"></span>



		<br><br>
       <h2 style="    margin-bottom: 25px;"><span v-html="$t('blog.registerUnsupportedCountriesBlogContent_2')"></span></h2>
		<div style="margin-left:10px;">

			<ol class="steps-list">
				<li><span v-html="$t('blog.registerUnsupportedCountriesBlogContent_3')"></span></li>
				<li><span v-html="$t('blog.registerUnsupportedCountriesBlogContent_4')"></span>
				<v-img
						alt="Click on the avatar on the top right of the screen"
						class="shrink mr-2 step-image"
						contain
						src="../../assets/articles/how-to-register-in-unsupported-country/step1.png"
						transition="scale-transition"
						width="100px"

				/>
				</li>
				<li><span v-html="$t('blog.registerUnsupportedCountriesBlogContent_5')"></span>
				<v-img
							alt="Click on the avatar on the top right of the screen"
							class="shrink mr-2 step-image"
							contain
							src="../../assets/articles/how-to-register-in-unsupported-country/step2.png"
							transition="scale-transition"
							width="300px"

					/>
				</li>
				<li><span v-html="$t('blog.registerUnsupportedCountriesBlogContent_6')"></span>
				</li>
				<li> <span v-html="$t('blog.registerUnsupportedCountriesBlogContent_7')"></span>
				<v-img
							alt="Click on the avatar on the top right of the screen"
							class="shrink mr-2 step-image"
							contain
							src="../../assets/articles/how-to-register-in-unsupported-country/step3.png"
							transition="scale-transition"
							width="700px"

					/>
				</li>
				<li> <span v-html="$t('blog.registerUnsupportedCountriesBlogContent_8')"></span>
				<v-img
							alt="Click on the avatar on the top right of the screen"
							class="shrink mr-2 step-image"
							contain
							src="../../assets/articles/how-to-register-in-unsupported-country/step4.png"
							transition="scale-transition"
							width="500px"

					/>
				</li>
				<li> <span v-html="$t('blog.registerUnsupportedCountriesBlogContent_9')"></span>
				<v-img
							alt="Click on the avatar on the top right of the screen"
							class="shrink mr-2 step-image"
							contain
							src="../../assets/articles/how-to-register-in-unsupported-country/step5.png"
							transition="scale-transition"
							width="600px"

					/>
				</li>
				<li> <span v-html="$t('blog.registerUnsupportedCountriesBlogContent_10')"></span>
				<v-img
							alt="Click on the avatar on the top right of the screen"
							class="shrink mr-2 step-image"
							contain
							src="../../assets/articles/how-to-register-in-unsupported-country/step6.png"
							transition="scale-transition"
							width="100px"

					/>
				</li>
				<li> <span v-html="$t('blog.registerUnsupportedCountriesBlogContent_11')"></span>
				<v-img
						alt="Click on the avatar on the top right of the screen"
						class="shrink mr-2 step-image"
						contain
						src="../../assets/articles/how-to-register-in-unsupported-country/step6-a.png"
						transition="scale-transition"
						width="300px"

				/>
				<li> <span v-html="$t('blog.registerUnsupportedCountriesBlogContent_12')"></span>
				<v-img
						alt="Click on the avatar on the top right of the screen"
						class="shrink mr-2 step-image"
						contain
						src="../../assets/articles/how-to-register-in-unsupported-country/step6-b.png"
						transition="scale-transition"
						width="300px"

				/>
				</li>
				<li>  <span v-html="$t('blog.registerUnsupportedCountriesBlogContent_13')"></span>
				<v-img
							alt="Click on the avatar on the top right of the screen"
							class="shrink mr-2 step-image"
							contain
							src="../../assets/articles/how-to-register-in-unsupported-country/step7.png"
							transition="scale-transition"
							width="300px"

					/>
				</li>
				<li> <span v-html="$t('blog.registerUnsupportedCountriesBlogContent_14')"></span>
				<v-img
							alt="Click on the avatar on the top right of the screen"
							class="shrink mr-2 step-image"
							contain
							src="../../assets/articles/how-to-register-in-unsupported-country/step8.png"
							transition="scale-transition"
							width="200px"

					/>
				</li>
				<li> <span v-html="$t('blog.registerUnsupportedCountriesBlogContent_15')"></span>
				<v-img
							alt="Click on the avatar on the top right of the screen"
							class="shrink mr-2 step-image"
							contain
							src="../../assets/articles/how-to-register-in-unsupported-country/step9.png"
							transition="scale-transition"
							width="200px"

					/>
				</li>
			</ol>

		</div>
<br><br>
			<h3 style="    margin-bottom: 25px;"><span v-html="$t('blog.registerUnsupportedCountriesBlogContent_16')"></span></h3>
		<div style="margin-left:10px;">
			 <span v-html="$t('blog.registerUnsupportedCountriesBlogContent_17')"></span> <router-link to="how-to-register-a-stadia-account"><span v-html="$t('blog.registerUnsupportedCountriesBlogContent_18')"></span></router-link>.
		</div>


    </v-card-text>

   <v-card-subtitle class="pb-0" >By GameEnable team  •  October 09, 2020  </v-card-subtitle>
		</v-card>


        </div>
</template>

<style scoped>

	.step-image{

			border:1px solid #cecece;
		border-radius:3px;

	}

	.steps-list > li{

		margin-bottom: 50px; font-weight: 500;

	}

</style>

<script>

  import i18n from "@/i18n";
  import Page from '../../mixins/page'

  export default {
    name: 'how-to-register-in-unsupported-country',
	  mixins: [Page],
	  data: ()=>({
		  id: 'how-to-register-in-unsupported-country'
	  }),
    computed: {
		pageTitle(){
			return i18n.t('blog.registerUnsupportedCountriesBlogPageTitle');
		},
		pageDescription(){
			return i18n.t('blog.registerUnsupportedCountriesBlogPageDescription');
		},
      title() {return i18n.t('blog.registerUnsupportedCountriesBlogTitle')}
    }
  };
</script>
